import { useEffect, useRef } from "react";

export default function CursorFX() {
  const ring = useRef(null);
  const dot = useRef(null);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return undefined;
    let x = -100, y = -100, rx = -100, ry = -100, raf;
    const move = (e) => {
      x = e.clientX; y = e.clientY;
      dot.current.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      const hot = e.target.closest && e.target.closest("a,button,input,textarea,select,[role=button],.cursor-pointer");
      ring.current.dataset.hot = hot ? "1" : "0";
    };
    const down = (e) => {
      ring.current.dataset.down = "1";
      const hot = e.target.closest && e.target.closest("a,button,[role=button],.cursor-pointer");
      const el = document.createElement("div");
      el.className = "click-x";
      el.style.left = `${e.clientX}px`; el.style.top = `${e.clientY}px`;
      el.style.setProperty("--cx", hot ? "#ff2020" : "#ffff00");
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 460);
    };
    const up = () => { ring.current.dataset.down = "0"; };
    const loop = () => {
      rx += (x - rx) * 0.2; ry += (y - ry) * 0.2;
      ring.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mousedown", down);
    window.addEventListener("mouseup", up);
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mousedown", down);
      window.removeEventListener("mouseup", up);
    };
  }, []);

  return (
    <>
      <div ref={ring} className="cursor-ring" data-hot="0" data-down="0" aria-hidden="true" data-testid="cursor-ring"><i /><i /><i /><i /></div>
      <div ref={dot} className="cursor-dot" aria-hidden="true" />
    </>
  );
}
